import type { ProjectResponse } from '@/model/project/dto.generated';
import type { ProjectSwitcherOption } from '@/viewmodel/features/project/types';

export const toProjectSwitcherOption = (project: ProjectResponse): ProjectSwitcherOption => ({
  value: project.id,
  label: project.slug || project.name,
});
